<template>
    <div>
        <el-row>
            <el-col :span="24" style="text-align: left;"><el-button type="primary" size="small" round
                    @click="openDialog(null)">添加</el-button></el-col>
        </el-row>

        <table style="width: 80%;">
            <tr v-for="item in newsData" :key="item.id" @click="rowClick(item)">
                <td class="col-md-2 content_padding news_content_date">
                    <div class="card-body news_content_date_body">
                        <!-- <h3> {{item.happenDate}} </h3> -->
                        <!-- <p>— {{item.year}} —</p> -->
                        <p> {{item.happenDate}} </p>
                    </div>
                </td>
                <td class="col-md-6-1 content_padding">
                    <div class="col-md-6-1 content_padding">
                        <div class="overlay  border-0 text-left pb-2">
                            <h5 class="card-title news_title">{{item.title}}</h5>
                            <!-- <p class="card-text text-muted" >
                                {{item.summary}}
                            </p> -->
                            <div v-html="item.summary"></div>
                        </div>
                    </div>
                </td>
                <td class="col-md-2 content_padding">
                    <div class="overlay border-0">
                        <img class="card-img" :src="item.url" alt="Card image" style="max-height: 9rem;">
                    </div>
                </td>
                <td class="col-md-1-1 content_padding">
                    <el-button type="primary" size="mini" icon="el-icon-edit" circle
                        @click="openDialog(item)"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" circle
                        @click="deleteNews(item.id)"></el-button>
                    <el-button type="warning" size="mini" icon="el-icon-star-off" circle
                        @click="showDetail(item.pdfUrl)"></el-button>
                </td>

            </tr>
        </table>
        <!-- 详情 弹窗 -->
        <el-dialog title="提示" :visible.sync="isdetail" width="60%" :before-close="detailClose">
            <div>
                <embed :src="detailInfo" type="application/pdf" width="100%" height="700px">
            </div>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="dialogVisible" width="60%">
            <el-form :model="currentRow">
                <el-form-item label="日期" :label-width="formLabelWidth">
                    <el-date-picker v-model="currentRow.happenDate" type="date"
                        style="display: inline;margin-left: 5px; " placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="标题" :label-width="formLabelWidth">
                    <el-input placeholder="请输入标题" v-model="currentRow.title" style="display: inline;margin-left: 5px; "
                        clearable required>
                    </el-input>
                </el-form-item>
                <el-form-item label="新品" :label-width="formLabelWidth">
                    <el-select v-model="currentRow.isNew" placeholder="请选择" style="margin-left: 5px; width: 980px;">
                        <el-option v-for="option in listIsnew" :key="option.id" :label="option.name" :value="option.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="概述" :label-width="formLabelWidth">
                    <!-- <vue-editor v-model="currentRow.summary" :options="editorOptions"></vue-editor> -->
                    <ckeditor v-model="currentRow.summary" :config="editorConfig"></ckeditor>
                </el-form-item>
                <el-form-item label="PDF名称" :label-width="formLabelWidth">
                    <el-input placeholder="请输入PDF名称" v-model="currentRow.pdfUrl"
                        style="display: inline;margin-left: 5px; " clearable required>
                    </el-input>
                </el-form-item>
                <table>
                    <tr>
                        <td>
                            <el-form-item label="封面图" :label-width="formLabelWidth">
                                <el-upload class="avatar-uploader" :before-upload="beforeUpload" action=""
                                    :show-file-list="false" :on-change="handleFileChange" :file-list="fileList">
                                    <img v-if="currentRow.url" :src="currentRow.url" class="avatar" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </td>
                        <!-- <td>
                            <el-form-item label="画册文件" :label-width="formLabelWidth">
                                <el-upload class="avatar-uploader" :before-upload="beforeUpload" action=""
                                    :show-file-list="false" :on-change="handleFileChange1" :file-list="fileList2">

                                    <div v-if="currentRow.pdfUrl">
                                        <embed :src="currentRow.pdfUrl" type="application/pdf" width="100%"
                                            height="600px">
                                    </div>
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </el-form-item>
                        </td> -->
                    </tr>
                </table>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveInfo">确 定</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>

    import { getDataList, submitAlbum, delAlbum } from "@/api/rbac/album";
    import { upLoadFile } from "@/api/rbac/upload";

    // import { VueEditor } from "vue2-editor";
    export default {
        components: {
            // VueEditor
        },
        data() {
            return {
                dialogVisible: false,
                newsData: [],
                currentRow: { id: 0, title: '', summary: '', content: '', year: '', monthDay: '', url: '', happenDate: new Date(), date: new Date(), operaterID: 0,isNew:0 },
                formLabelWidth: '120px',
                fileList: [],
                fileList2: [],
                editorConfig: {
                    extraPlugins: 'font,colorbutton', // 添加字体和颜色插件
                    toolbar: [
                        { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'] },
                        { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote'] },
                        { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                        { name: 'colors', items: ['TextColor', 'BGColor'] },
                        // { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 视频功能
                        { name: 'insert', items: ['Image', 'Table', 'MediaEmbed'] }, // 添加图片按钮
                        { name: 'links', items: ['Link', 'Unlink'] },
                    ],
                    font_names: 'Arial/Arial, Helvetica, sans-serif;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif',
                    fontSize_sizes: '9/9px;11/11px;13/13px;16/16px;18/18px;21/21px;24/24px;28/28px;32/32px',
                    language: 'zh-cn'
                },
                isdetail: false,
                detailInfo: "",
                listIsnew: [{ id: 1, name: '是' }, { id: 0, name: '否' }],
            }
        },
        created() {
            this.loadDataList();
        },
        methods: {
            async loadDataList() {
                try {
                    getDataList().then(res => {
                        if (res.data.length == 0) {
                            // console.log(this.dataList)
                        }
                        else {
                            this.newsData = res.data;
                            this.newsData.forEach(comNew => {
                                comNew.url = "../../../assets/img/album/" + comNew.url;
                                // comNew.pdfUrl="../../../assets/img/album/" + comNew.pdfUrl;
                            });
                        }
                    })
                } catch (error) {
                    console.error('获取失败:', error);
                }
            },
            rowClick(item) {
                this.currentRow = { ...item }
            },

            openDialog(item) {
                this.dialogVisible = true
                // 深拷贝避免直接修改原数据
                if (item) {
                    this.currentRow = { ...item }
                } else {
                    this.currentRow = { id: 0, title: '', summary: '', url: '', pdfUrl: '', happenDate: new Date(), date: new Date(), operaterID: 0 ,isNew:0,};
                }
            },
            beforeUpload(file) {
                //   const isImage = file.type.startsWith('image/');
                //   const isVideo = file.type.startsWith('video/');
                console.log(file)
                return false; // 阻止自动上传
            },
            handleFileChange(file, fileList) {
                console.log('fileList', fileList)
                this.fileList = [];
                this.fileList.push(file)
                if (file.status === 'ready') {
                    // 当文件状态为 ready 时，生成预览 URL
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.currentRow.url = e.target.result;
                    };
                    reader.readAsDataURL(file.raw);
                }
            },
            handleFileChange1(file, fileList) {
                console.log('fileList', fileList)
                this.fileList2 = [];
                this.fileList2.push(file)
                if (file.status === 'ready') {
                    // 生成预览 URL
                    const reader = new FileReader();

                    // 读取文件内容
                    reader.onload = (e) => {
                        // 生成一个 Blob URL
                        const blob = new Blob([e.target.result], { type: 'application/pdf' });
                        this.currentRow.pdfUrl = URL.createObjectURL(blob);
                        // console.log(URL.createObjectURL(blob))
                    };

                    reader.readAsArrayBuffer(file.raw);
                }
            },

            saveInfo() {
                if (this.currentRow.happenDate == null || this.currentRow.happenDate.String) {
                    return alert("请选择日期")
                }
                if (!String(this.currentRow.title).trim()) {
                    return alert("请填写标题")
                }
                if (!String(this.currentRow.summary).trim()) {
                    return alert("请填写概述")
                }

                if (this.fileList.length == 0 && this.currentRow.id == 0) {
                    return alert("请选择封面图")
                }
                if (!String(this.currentRow.summary).trim()) {
                    return alert("请填写PDF名称")
                }
                try {
                    submitAlbum(this.currentRow).then(res => {
                        if (res.data.success) {
                            //上传封面图
                            if (this.fileList.length > 0) {
                                const formCover = new FormData();
                                this.fileList.forEach((file) => {
                                    formCover.append('files[]', file.raw);
                                });
                                formCover.append("strType", "album")
                                formCover.append("partID", res.data.id)
                                upLoadFile(formCover).then(pCover => {
                                    if (pCover.data.success) {
                                        //
                                    }
                                    else {
                                        alert('封面图上传失败');
                                    }
                                })
                            }
                            //上传主页主图
                            if (this.fileList2.length > 0) {
                                const formMain = new FormData();
                                this.fileList2.forEach((file) => {
                                    formMain.append('files[]', file.raw);
                                });
                                formMain.append("strType", "albumMain")
                                formMain.append("partID", res.data.id)
                                upLoadFile(formMain).then(pMain => {
                                    if (pMain.data.success) {
                                        // alert('主页主图上传成功');
                                    }
                                    else {
                                        alert('画册文件上传失败');
                                    }
                                })
                            }
                            this.fileList = [];
                            this.fileList2 = [];
                            this.loadDataList();
                            this.dialogVisible = false;
                            this.popData = {
                                id: 0, name: '', typeID: 0, code: '', isNew: 0, mainCodeID: 0, operaterID: 0, date: new Date()
                                , heppenDate: new Date(), typeName: '', maincode: '', operaterMan: '', depth: '', height: '', length: '', weight: '', ledPower: ''
                                , voltage: '', maxPower: '', beam: '', lumes: '', function: '', certification: '', ipRating: '', detailID: 0, isAudit: 0
                                , remark: '', sort: 0, isMain: 0, tubeUrl: '', inSize: '', isProduct: 1
                            };
                        }
                    })
                } catch (error) {
                    alert('未成功');
                }
            },
            showDetail(content) {
                var str = '/Brochure/' + content + '/' + content + '.html'
                window.open(str, '_blank');
                // this.detailInfo = content;
                // this.isdetail = true;
            },
            deleteAlbum(id) {
                this.$confirm('确定删除该, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    try {
                        delAlbum(id).then(res => {
                            if (res.data == "ok") {
                                this.loadDataList();
                            }
                        })

                        this.currentRow = {};
                    } catch (error) {
                        console.error('删除失败:', error);
                    }
                }).catch(() => {
                });
            },
            detailClose() {
                this.detailInfo = "";
                this.isdetail = false;
            },
        }
    }
</script>
<style scoped>
    .avatar-uploader {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 178px;
        height: 178px;
    }

    .avatar-uploader:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>